module.exports = __webpack_public_path__ + "img/medaille.8f8aea3.svg";